import classnames from "classnames";
import { BlueOutlineButton } from "components/components/BlueOutlineButton/BlueOutlineButton";
import { SvgIconName } from "components/components/Icon/Icon";
import React from "react";

import { ChartFilterButtonContainer } from "./style";

const ChartFilterButton: React.FC<{
  toggleChartFilterDrawer?: () => void;
  showChartFilterDrawer?: boolean;
}> = ({ toggleChartFilterDrawer, showChartFilterDrawer }) => (
  <ChartFilterButtonContainer data-test-id="chart-filter-button-container">
    {toggleChartFilterDrawer && (
      <BlueOutlineButton
        onClick={toggleChartFilterDrawer}
        className={classnames("toggle", { active: showChartFilterDrawer })}
        buttonText="Filter"
        iconName={SvgIconName.Filter}
      />
    )}
  </ChartFilterButtonContainer>
);

export default ChartFilterButton;
